module.exports = __webpack_public_path__ + "static/img/intro2.b34bc99b.png";